import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import LatestSection from './components/LatestSection';

export default function Home() {
  useEffect(() => {
    document.title = '51cg吃瓜网 - 51cg今日大瓜必吃大瓜与51cgfun今日吃瓜 | 最新吃瓜热闻速递';
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': '51cg吃瓜网首页',
    'description': '51cg今日大瓜必吃大瓜合集，覆盖51cgfun今日吃瓜、51cg.fun今日吃瓜及51cg吃瓜热点事件，娱乐爆料与大瓜速递一网打尽。',
    'url': 'https://51cg.fun',
    'inLanguage': 'zh-CN',
    'isPartOf': {
      '@type': 'WebSite',
      'name': '51cg吃瓜网',
      'url': 'https://51cg.fun',
    },
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />

        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-6">
          <Breadcrumb items={[{ label: '首页' }]} />
        </div>

        <TrendingSection />
        <LatestSection />
      </main>

      <Footer />

      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </>
  );
}